export default __webpack_public_path__ + "static/media/python.eb8ab6ed.svg";